import axiosInstance from '@/services';
import { APIS } from '@/utilities/constants';

export const CodesAPI = {
  getCodes: async (tableName: string) => {
    const response = await axiosInstance.get(`${APIS.CODES}/${tableName}`);

    return response;
  },
};
